import { createFileRoute, redirect } from "@tanstack/react-router";
import { waitingOnYouSearch } from "./waiting-on-you";

/**
 * The step queue's oldest address (NAV-84), forwarding to where the steps live
 * now — the steps tab of "Waiting on you" (Jira NAV-111).
 *
 * Straight there rather than through `/end-user/evaluation-steps`, which also
 * forwards: two hops would put a redirect in the history of a link that is
 * followed out of an email, and the second one has nothing to add.
 *
 * Every step reminder and clarification notice minted before NAV-84 links here,
 * with the `?request=` that decides which card opens, so the address has to keep
 * resolving — and it has to arrive at the same card, which is why the params are
 * validated here and forwarded rather than dropped. New notifications are minted
 * against the current address (`send_step_reminders_use_case`,
 * `notify_clarification_use_case`).
 */
export const Route = createFileRoute("/end-user/approvals")({
  validateSearch: waitingOnYouSearch,
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/end-user/waiting-on-you",
      search: { ...search, tab: "steps" },
      replace: true,
    });
  },
});
